import { getLogoUrl } from '@/config/branding';

const PLATFORM_CHECKOUT_TEMPLATE_IDS = new Set(['shopify-default', 'woocommerce-default']);

/** Merchant-uploaded logo, or white-label / Tagada fallback for checkout config. */
export function resolveSetupStoreLogoUrl(logoUrl?: string | null): string {
  const custom = logoUrl?.trim();
  return custom || getLogoUrl();
}

export function hasSetupStoreLogoUpload(logoUrl?: string | null): boolean {
  return Boolean(logoUrl?.trim());
}

/** Store logo on template cards — not on platform-branded funnel templates. */
export function shouldUseStoreLogoOnCheckoutTemplate(templateId: string): boolean {
  return !PLATFORM_CHECKOUT_TEMPLATE_IDS.has(templateId);
}
